import { render } from "./SupplierEdit.vue?vue&type=template&id=4f0bb01b&scoped=true"
import script from "./SupplierEdit.vue?vue&type=script&lang=js"
export * from "./SupplierEdit.vue?vue&type=script&lang=js"

import "./SupplierEdit.vue?vue&type=style&index=0&id=4f0bb01b&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f0bb01b"]])

export default __exports__